import { MessageOutlined } from '@ant-design/icons';

import BaseNodeContainer from '../../BaseNodeContainer';

export default function MessageNode(node: any) {

  return (
    <BaseNodeContainer
      title='Mensagem'
      node={node}
      IconComponent={<MessageOutlined />}
      onPressLink={node.onPressAddLinkedNode}
      defaultMessages={node.defaultMessages}
      defaultInputInstructions={node.defaultInputInstructions}
    />
  );
}